function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["item", "theme", "tooltipColor", "onItemClick", "companyId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Layout, Menu, Tooltip, Spin, PaperIcon } from '@nackle/paper';
var SubMenu = Menu.SubMenu,
    ItemGroup = Menu.ItemGroup,
    Item = Menu.Item;
var Sider = Layout.Sider;
import { getString } from '@nackle/intl-tools';
import NavigationService from './navigation-service';
import './nackle-menu.less';

var NackleMenu = /*#__PURE__*/function (_Component) {
  _inherits(NackleMenu, _Component);

  var _super = _createSuper(NackleMenu);

  function NackleMenu() {
    var _this;

    _classCallCheck(this, NackleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      navigationType: '',
      navigationLoaded: false,
      navigationData: {},
      cmxBundleLoaded: false,
      defaultOpenKeys: [],
      defaultSelectedKeys: []
    });

    _defineProperty(_assertThisInitialized(_this), "loadNavigation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, type, auth, navigationService, data, _this$getDefaultKeys, defaultOpenKeys, defaultSelectedKeys;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, type = _this$props.type, auth = _this$props.auth;
              navigationService = new NavigationService(auth.state);
              _context.next = 4;
              return navigationService.getMenu(type);

            case 4:
              data = _context.sent;
              _this$getDefaultKeys = _this.getDefaultKeys(data), defaultOpenKeys = _this$getDefaultKeys.defaultOpenKeys, defaultSelectedKeys = _this$getDefaultKeys.defaultSelectedKeys;

              _this.setState(function (state, props) {
                return {
                  navigationData: data,
                  navigationLoaded: true,
                  defaultOpenKeys: defaultOpenKeys,
                  defaultSelectedKeys: defaultSelectedKeys
                };
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getDefaultKeys", function (navigationData) {
      if (!navigationData || !navigationData.sections) {
        return [];
      }

      var defaultOpenKeys = [];
      var defaultSelectedKeys = [];

      var doesUrlStartWithWindowLocation = function doesUrlStartWithWindowLocation(itemUrl) {
        return itemUrl.indexOf(window.location.origin) === 0;
      };

      var locationUrlParts = window.location.href.split('//')[1].split('#')[0].split('/');

      var doesUrlMatchWindowLocation = function doesUrlMatchWindowLocation(itemUrl) {
        var itemUrlParts = itemUrl.split('//')[1].split('#')[0].split('/');

        if (itemUrlParts.length !== locationUrlParts.length) {
          return false;
        }

        for (var i = 0; i < itemUrlParts.length; i++) {
          if (itemUrlParts[i] !== locationUrlParts[i] && itemUrlParts[i] !== '${companyId}') {
            return false;
          }
        }

        return true;
      };

      var addKeys = function addKeys(parentKeys, sections) {
        sections.forEach(function (section) {
          section.items.forEach(function (item) {
            if (item.url && doesUrlStartWithWindowLocation(item.url)) {
              parentKeys.forEach(function (key) {
                return defaultOpenKeys.push(key);
              });
              defaultOpenKeys.push(section.id);
            }

            if (item.url && doesUrlMatchWindowLocation(item.url)) {
              defaultSelectedKeys.push(item.id);
            }

            if (item.subMenu) {
              addKeys([].concat(_toConsumableArray(parentKeys), [section.id]), item.subMenu.sections);
            }
          });
        });
      };

      addKeys([], navigationData.sections);
      return {
        defaultOpenKeys: defaultOpenKeys,
        defaultSelectedKeys: defaultSelectedKeys
      };
    });

    return _this;
  }

  _createClass(NackleMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadNavigation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          auth = _this$props2.auth,
          cmxBundleLoaded = _this$props2.cmxBundleLoaded,
          tooltipColor = _this$props2.tooltipColor,
          theme = _this$props2.theme,
          mode = _this$props2.mode,
          width = _this$props2.width,
          collapsible = _this$props2.collapsible,
          onItemClick = _this$props2.onItemClick;
      var _this$state = this.state,
          navigationLoaded = _this$state.navigationLoaded,
          navigationData = _this$state.navigationData,
          defaultOpenKeys = _this$state.defaultOpenKeys,
          defaultSelectedKeys = _this$state.defaultSelectedKeys;
      var loaded = cmxBundleLoaded && navigationLoaded;
      return /*#__PURE__*/React.createElement(Sider, {
        className: classNames('nackle-menu', {
          'is-loaded': loaded
        }),
        collapsible: collapsible,
        width: width
      }, !loaded ? /*#__PURE__*/React.createElement("div", {
        className: "nackle-menu-activity-indicator"
      }, /*#__PURE__*/React.createElement(Spin, {
        size: "large"
      })) : /*#__PURE__*/React.createElement(Menu, {
        theme: theme,
        mode: mode,
        defaultOpenKeys: defaultOpenKeys,
        defaultSelectedKeys: defaultSelectedKeys
      }, navigationData.sections.map(function (section) {
        return /*#__PURE__*/React.createElement(NackleMenuItem, {
          key: section.id,
          item: section,
          tooltipColor: tooltipColor,
          theme: theme,
          onItemClick: onItemClick,
          companyId: auth.state.claims.company_id
        });
      })));
    }
  }]);

  return NackleMenu;
}(Component);

_defineProperty(NackleMenu, "propTypes", {
  type: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']).isRequired,
  width: PropTypes.number.isRequired,
  collapsible: PropTypes.bool.isRequired,
  auth: PropTypes.object.isRequired,
  cmxBundleLoaded: PropTypes.bool.isRequired,
  tooltipColor: PropTypes.string.isRequired,
  onItemClick: PropTypes.func
});

_defineProperty(NackleMenu, "defaultProps", {
  type: 'STUDIO',
  theme: 'dark',
  mode: 'inline',
  tooltipColor: 'geekblue',
  width: 256,
  collapsible: true
});

var NackleMenuItem = /*#__PURE__*/function (_Component2) {
  _inherits(NackleMenuItem, _Component2);

  var _super2 = _createSuper(NackleMenuItem);

  function NackleMenuItem() {
    var _this2;

    _classCallCheck(this, NackleMenuItem);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "handleClick", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this2$props, item, onItemClick, companyId, url, _preventDefault, title, pathname;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2$props = _this2.props, item = _this2$props.item, onItemClick = _this2$props.onItemClick, companyId = _this2$props.companyId;
              url = item.url ? item.url.replace('${companyId}', companyId) : undefined;
              _preventDefault = false;

              if (!(typeof onItemClick === 'function')) {
                _context2.next = 6;
                break;
              }

              _context2.next = 6;
              return onItemClick({
                companyId: companyId,
                item: item,
                url: url,
                preventDefault: function preventDefault() {
                  _preventDefault = true;
                }
              });

            case 6:
              if (!(!url || _preventDefault)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              if (url.indexOf(window.location.origin) === 0) {
                title = item.labelKey ? getString(item.labelKey) : undefined;
                pathname = url.substring(window.location.origin.length);
                history.pushState(undefined, title, pathname);
              } else {
                window.location = url;
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    return _this2;
  }

  _createClass(NackleMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          item = _this$props3.item,
          theme = _this$props3.theme,
          tooltipColor = _this$props3.tooltipColor,
          onItemClick = _this$props3.onItemClick,
          companyId = _this$props3.companyId,
          props = _objectWithoutProperties(_this$props3, _excluded);

      var id = item.id,
          iconName = item.iconName,
          labelKey = item.labelKey,
          descriptionKey = item.descriptionKey,
          subMenu = item.subMenu,
          items = item.items;
      var labelText = labelKey ? getString(labelKey) : undefined;
      var tooltipText = descriptionKey ? getString(descriptionKey) : undefined;

      if (subMenu || items) {
        return /*#__PURE__*/React.createElement(SubMenu, _extends({
          key: id,
          icon: iconName && /*#__PURE__*/React.createElement(PaperIcon, {
            icon: iconName,
            className: "menu-icon"
          }),
          title: /*#__PURE__*/React.createElement(Tooltip, {
            placement: "rightTop",
            title: tooltipText,
            mouseEnterDelay: 2,
            color: tooltipColor
          }, /*#__PURE__*/React.createElement("span", null, labelText))
        }, props), /*#__PURE__*/React.createElement(ItemGroup, {
          title: labelText,
          className: classNames('nackle-menu-collapsed-header', theme)
        }), subMenu && subMenu.sections.map(function (section) {
          var sectionLabelText = section.labelKey ? getString(section.labelKey) : undefined;
          var sectionTooltipText = section.descriptionKey ? getString(section.descriptionKey) : undefined;
          return /*#__PURE__*/React.createElement(Tooltip, {
            placement: "rightTop",
            title: sectionTooltipText,
            mouseEnterDelay: 2,
            color: tooltipColor
          }, /*#__PURE__*/React.createElement(ItemGroup, {
            id: section.id,
            title: sectionLabelText
          }, section.items.map(function (subMenuItem) {
            return /*#__PURE__*/React.createElement(NackleMenuItem, {
              key: subMenuItem.id,
              item: subMenuItem,
              tooltipColor: tooltipColor,
              onItemClick: onItemClick,
              companyId: companyId
            });
          })));
        }), items && items.map(function (subMenuItem) {
          return /*#__PURE__*/React.createElement(NackleMenuItem, {
            key: subMenuItem.id,
            item: subMenuItem,
            tooltipColor: tooltipColor,
            onItemClick: onItemClick,
            companyId: companyId
          });
        }));
      }

      return /*#__PURE__*/React.createElement(Item, _extends({
        key: id
      }, props, {
        icon: iconName && /*#__PURE__*/React.createElement(PaperIcon, {
          icon: iconName,
          className: "menu-icon"
        }),
        onClick: this.handleClick
      }), /*#__PURE__*/React.createElement(Tooltip, {
        placement: "rightTop",
        title: tooltipText,
        mouseEnterDelay: 2,
        color: tooltipColor
      }, /*#__PURE__*/React.createElement("span", null, labelText)));
    }
  }]);

  return NackleMenuItem;
}(Component);

export default NackleMenu;
//# sourceMappingURL=nackle-menu.js.map